import { useEffect, useState } from "react";
import { formatDateTime } from "../lib/dateFormat";
import ERPAnalyticsHeader from "../components/ERPAnalyticsHeader";
import { api } from "../lib/api";
import { Download } from "lucide-react";

export default function Exports() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/exports").then((r) => setRows(r.data.exports || []));
  }, []);

  return (
    <div className="erp-home-shell">
      <ERPAnalyticsHeader />

      <main className="erp-content">
        <div className="erp-page-title-row">
          <div>
            <h1>Exports</h1>
            <p>History of CSV exports executed in this workspace.</p>
          </div>
        </div>

        <div className="erp-card">
          <table className="tbl" data-testid="exports-table">
            <thead>
              <tr>
                <th>Time</th>
                <th>User</th>
                <th>Resource</th>
                <th>Rows</th>
                <th>Type</th>
              </tr>
            </thead>

            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td className="font-mono text-[12px]">
                    {formatDateTime(r.created_at)}
                  </td>
                  <td>{r.user_email || "—"}</td>
                  <td className="font-mono text-[12px]">{r.resource_id || "—"}</td>
                  <td className="numeric">{r.detail?.rows ?? "—"}</td>
                  <td>
                    <span className="pill">
                      <Download size={11} strokeWidth={1.8} className="inline mr-1" />
                      CSV
                    </span>
                  </td>
                </tr>
              ))}

              {rows.length === 0 && (
                <tr>
                  <td colSpan={5} className="text-center py-6" style={{ color: "var(--c-text-muted)" }}>
                    No exports recorded yet. Use the download icon on any widget or report to generate a CSV.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}
